import { render, staticRenderFns } from "./IntegratedSalesView.vue?vue&type=template&id=bdfadc2e&scoped=true"
import script from "./IntegratedSalesView.vue?vue&type=script&lang=js"
export * from "./IntegratedSalesView.vue?vue&type=script&lang=js"
import style0 from "./IntegratedSalesView.vue?vue&type=style&index=0&id=bdfadc2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdfadc2e",
  null
  
)

export default component.exports